export default {"src":"/_next/static/media/castbox-badge-light.b6ee781b.svg","height":40,"width":130,"blurWidth":0,"blurHeight":0};